(function () {
  'use strict';
  const chart = [
    [18, 46, 70, 76, '9-18 months'], [20, 51, 76, 82, '1-2 years'],
    [22, 56, 82, 88, '2 years'], [24, 61, 88, 94, '2-3 years'],
    [26, 66, 94, 100, '3-4 years'], [28, 71, 100, 106, '4-5 years'],
    [30, 76, 106, 112, '5-6 years'], [32, 81, 112, 118, '6-7 years'],
    [34, 86, 118, 124, '7-8 years'], [36, 91, 124, 130, '8-9 years'],
    [38, 97, 130, 136, '9-10 years'], [40, 102, 136, 142, '10-11 years'],
    [42, 107, 142, 148, '11-12 years'], [44, 112, 148, 154, '12-13 years'],
    [46, 117, 154, 160, '13-14 years'], [48, 122, 160, 166, '14-15 years']
  ];

  function recommend(raw, variants, color = '') {
    const value = String(raw).trim();
    if (!/^\d+(?:\.\d+)?$/.test(value)) return { state: 'invalid' };
    const height = Number(value);
    if (!Number.isFinite(height) || height < 70 || height > 166) return { state: 'outside' };
    // A shared endpoint belongs to the next band; the final 166cm endpoint is included.
    const row = chart.find((entry, index) => height >= entry[2] && (height < entry[3] || (index === chart.length - 1 && height === entry[3])));
    const matches = variants.filter(variant => String(variant.size).trim() === String(row[0]));
    const selected = color ? matches.filter(variant => variant.color === color) : matches;
    return {
      size: row[0], length: row[1], age: row[4],
      state: matches.length === 0 ? 'unsupported' : selected.length === 0 ? 'unavailable-option' : selected.some(variant => variant.available === true) ? 'available' : 'sold-out'
    };
  }

  if (typeof module !== 'undefined' && module.exports) module.exports = { chart, recommend };
  if (typeof window === 'undefined' || customElements.get('ii-children-size-finder')) return;

  customElements.define('ii-children-size-finder', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      const data = this.querySelector('[data-child-sizes]');
      const input = this.querySelector('[data-child-height]');
      if (!data || !input) return;
      this.ready = true;
      const payload = JSON.parse(data.textContent);
      const variants = payload.variants.map(variant => ({size: variant.options[payload.sizeIndex], color: variant.options[payload.colorIndex] || '', available: variant.available}));
      const scope = this.closest('.shopify-section') || this.parentElement;
      const picker = scope.querySelector(`block-variant-picker[data-product-id="${this.dataset.productId}"]`);
      const selectedColor = () => {
        if (payload.colorIndex < 0 || !picker) return '';
        const control = picker.querySelector('input[name="Color"]:checked, input[name="Colour"]:checked, select[name="options[Color]"], select[name="options[Colour]"]');
        return control ? control.value : '';
      };
      const calculate = () => {
        const color = selectedColor();
        const result = recommend(input.value, variants, color);
        const title = this.querySelector('[data-child-size]');
        const detail = this.querySelector('[data-child-detail]');
        const stock = this.querySelector('[data-child-stock]');
        input.setAttribute('aria-invalid', ['invalid', 'outside'].includes(result.state) ? 'true' : 'false');
        this.dataset.resultState = result.state;
        if (result.state === 'invalid' || result.state === 'outside') {
          title.textContent = result.state === 'invalid' ? 'Enter a height in centimetres' : 'Outside this height guide';
          detail.textContent = result.state === 'invalid' ? 'Use a number, for example 122 or 122.5.' : 'This guide covers 70 to 166 cm. Please ask us for guidance outside this range.';
          stock.textContent = 'No size has been selected.';
          return;
        }
        title.textContent = `Suggested size ${result.size}`;
        detail.textContent = `${result.size}-inch garment length (approx. ${result.length} cm). Approximate age: ${result.age}.`;
        stock.textContent = result.state === 'unsupported'
          ? `Size ${result.size} is not offered in this style. Please ask us for help; we have not substituted another size.`
          : result.state === 'unavailable-option'
            ? `Size ${result.size} is not offered in ${color}. We have not substituted another size.`
            : result.state === 'sold-out'
              ? `Size ${result.size} is currently sold out${color ? ` in ${color}` : ' in this style'}. We have not substituted another size.`
              : `Size ${result.size} is available${color ? ` in ${color}` : ' in at least one option'}. Select it in the product options when you are ready.`;
      };
      this.querySelector('[data-child-calculate]').addEventListener('click', calculate);
      if (picker) picker.addEventListener('change', () => {
        if (this.hasAttribute('data-result-state')) calculate();
      });
      input.addEventListener('keydown', event => {
        if (event.key === 'Enter') { event.preventDefault(); calculate(); }
      });
      input.addEventListener('input', () => {
        input.removeAttribute('aria-invalid');
        this.removeAttribute('data-result-state');
        this.querySelector('[data-child-size]').textContent = 'Ready to check';
        this.querySelector('[data-child-detail]').textContent = 'Choose Find size to update the suggestion.';
        this.querySelector('[data-child-stock]').textContent = '';
      });
    }
  });
})();
